export const initConstantContact = () => {
  if (window.SignUpFormWidget) {
    window.SignUpFormWidget.main();
  }
}
